import * as Yup from 'yup';

export function WhatsappApiSchema() {
  return Yup.object({
    name: Yup.string()
      .max(512, 'Name must be at most 512 characters')
      .matches(
        /^[a-z0-9_]+$/,
        'Solo se permiten minúsculas, números y guion bajo (sin acentos ni caracteres especiales).',
      )
      .required('Name is required'),
    header: Yup.string().max(60, 'Name must be at most 255 characters'),
    text: Yup.string()
      .max(1024, 'Text must be at most 1024 characters')
      .required('Text is required'),
    footer: Yup.string().max(60, 'Footer must be at most 60 characters'),
    headerExample: Yup.string().max(
      60,
      'Header example must be at most 1024 characters',
    ),
    variables: Yup.array().of(
      Yup.object({
        name: Yup.string()
          .max(64, 'Variable name must be at most 64 characters')
          .required('Variable name is required'),
        example: Yup.string()
          .max(1024, 'Variable example must be at most 1024 characters')
          .required('Variable example is required'),
      }),
    ),
    buttons: Yup.array().of(
      Yup.object({
        index: Yup.number().required('Button index is required'),
        text: Yup.string()
          .max(25, 'Button text must be at most 25 characters')
          .when('type', {
            is: (type: string) => type !== 'COPY_CODE',
            then: (schema) => schema.required('Button text is required'),
            otherwise: (schema) => schema,
          }),
        url: Yup.string()
          .max(2000, 'URL must be at most 2000 characters')
          .when('type', {
            is: 'URL',
            then: (schema) =>
              schema
                .required('URL is required')
                .matches(/^https?:\/\//, 'Must start with http:// or https://'),
            otherwise: (schema) => schema,
          }),
        phone_number: Yup.string()
          .max(20, 'Phone number must be at most 20 characters')
          .when('type', {
            is: 'PHONE_NUMBER',
            then: (schema) => schema.required('Phone number is required'),
            otherwise: (schema) => schema,
          }),
        example: Yup.string()
          .max(15, 'Example must be at most 15 characters')
          .when('type', {
            is: 'COPY_CODE',
            then: (schema) =>
              schema.required('Example is required for copy code buttons'),
            otherwise: (schema) => schema,
          }),
        type: Yup.string().required('Button type is required'),
      }),
    ),
  });
}
